module.exports = __webpack_public_path__ + "static/media/studio 5 art style vibe gold black face.1280x1707.09147cd4.webp";